import GoogleMapBlock from "./GoogleMapBlockContainer";

export default GoogleMapBlock;
